// extracted by css-extract-rspack-plugin
export default {"link":"Link-module__link___KKzUO","disabled":"Link-module__disabled___zOOAB","brand":"Link-module__brand___h9uWO","brandBold":"Link-module__brandBold___ebPUo"};